import {
  type Configuration,
  PublicClientApplication
} from "@azure/msal-browser";

import { ENV_CONFIG } from "common/config/env.config";
/**
 * Configuration object to be passed to MSAL instance on creation.
 */
const msalConfig: Configuration = {
  auth: {
    clientId: ENV_CONFIG.CLIENT_ID,
    authority: ENV_CONFIG.AUTHORITY,
    redirectUri: ENV_CONFIG.REDIRECT_URI
  },
  cache: {
    cacheLocation: ENV_CONFIG.CACHE_LOCATION,
    storeAuthStateInCookie: false,
    secureCookies: true
  }
};

export const AUTH_SCOPES = {
  OPENID: "openid",
  PROFILE: "profile",
  USER_READ: "User.Read",
  USER_READ_BASIC_ALL: "User.ReadBasic.All"
  // DIRECTORY_ACCESS_AS_USER_ALL: "Directory.AccessAsUser.All",
};

export const authRequest = {
  scopes: [
    AUTH_SCOPES.USER_READ,
    AUTH_SCOPES.USER_READ_BASIC_ALL
    // AUTH_SCOPES.DIRECTORY_ACCESS_AS_USER_ALL,
    // AUTH_SCOPES.SITES_READ_ALL
  ]
};

// Add here scopes for id token to be used at MS Identity Platform endpoints.
export const protectedResources = {
  graph: {
    endpoint: "https://graph.microsoft.com/v1.0",
    scopes: [
      AUTH_SCOPES.USER_READ,
      AUTH_SCOPES.USER_READ_BASIC_ALL
      // AUTH_SCOPES.DIRECTORY_ACCESS_AS_USER_ALL,
      // AUTH_SCOPES.SITES_READ_ALL
    ]
  }
};

export const msalInstance = new PublicClientApplication(msalConfig);

export const SESSION_TIMEOUT = 1000 * 60 * 20; //20 min

// This method will enable API testing in local
// can disable in future
(window as any).getToken = async () => {
  // Only include valid scopes (never empty string)
  const apiScope = process.env.REACT_APP_API_SCOPE;
  const scopes =
    apiScope && apiScope.trim() !== "" ? [apiScope] : [AUTH_SCOPES.USER_READ];

  const request = { scopes };
  try {
    const result: any = await msalInstance.acquireTokenSilent(request);
    return result.accessToken;
  } catch (error: any) {
    // Always trigger interactive flow if consent_required or invalid_grant
    const needsConsent =
      error.errorCode === "consent_required" ||
      error.errorCode === "interaction_required" ||
      error.errorCode === "login_required" ||
      error.suberror === "consent_required" ||
      error.error === "invalid_grant";
    if (needsConsent) {
      try {
        const result: any = await msalInstance.acquireTokenPopup(request);
        return result.accessToken;
      } catch (popupError) {
        console.error("Interactive consent failed", popupError);
        throw popupError;
      }
    } else {
      throw error;
    }
  }
};
